var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.87033L8.90991 11.6303C9.44281 11.9529 10.0949 11.476 9.95468 10.873L9.18337 7.56344L11.7567 5.33368C12.2265 4.92699 11.9741 4.15569 11.357 4.1066L7.97033 3.81912L6.64509 0.691838C6.40669 0.123879 5.59331 0.123879 5.35491 0.691838L4.02967 3.81211L0.642956 4.09959C0.025914 4.14867 -0.226512 4.91998 0.243281 5.32666L2.81663 7.55643L2.04532 10.866C1.90509 11.469 2.55719 11.9458 3.09009 11.6233L6 9.87033Z",
    fill: "#E39435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/FullStar.818005796338e24ebca3ba9c974e9928.svg";
export { ForwardRef as ReactComponent };